// Prakash 10/29/2022 3031450488 Removed styles for Alignments.
// Prakash 10/30/2022 3031450488 Removed Card.
// akhila 1/12/2022 3031450488 passed props for workqueue
import React from 'react';
import SearchReportMasterContainer from './SearchReportMasterContainer';

function SearchRuleGroup({
  setTabValue,
  setReportCode,
  openTemplate,
  setOpenTemplate,
  setCopy,
  copy,
  setWorkQueue,
  workQueue,
  setEditExisting,
}) {
  return (
    <div>
      <SearchReportMasterContainer
        setTabValue={setTabValue}
        openTemplate={openTemplate}
        setOpenTemplate={setOpenTemplate}
        setCopy={setCopy}
        copy={copy}
        setWorkQueue={setWorkQueue}
        workQueue={workQueue}
        setEditExisting={setEditExisting}
      />
    </div>
  );
}

export default SearchRuleGroup;
